// extracted by mini-css-extract-plugin
var _1 = "EmbedComponent-module__animateUploadProgressBarWidth--bHaou";
var _2 = "EmbedComponent-module__animatedBackground--hxeeB";
var _3 = "EmbedComponent-module__container--lCPEA";
var _4 = "EmbedComponent-module__scaleContainer--yILQC";
var _5 = "EmbedComponent-module__scaledContent--AfMZn";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "scaleContainer", _5 as "scaledContent" }
